import Form from "../forms/form";
import React, { useRef, useEffect } from "react";
import Flower from "../../img/sunflowers_1000.png";
import { MdOutlinePlace } from "react-icons/md";
import { IoCalendarOutline } from "react-icons/io5";
import FirstScreenSpeacers from "../parts/firsrtscreen-speacers";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

function FirstScreenSlider({fsData}) {

    return (
        <section className="z-30 relative overflow-hidden bg-[#ffe94d] py-24 flex justify-center items-center h-full" id="top">

            <ScrollAnimation
                animatePreScroll="true"
                offset="0"
                animateIn="animate__fadeInDown relative z-40"
                delay="1000"
            >

                <div className="container w-full  xl:max-w-screen-xl m-auto max-sm:max-w-[94%] relative sm:bg-white bg-white/90 grid grid-cols-1 lg:grid-cols-[55%,45%] z-40 lg:mx-0">

                    {/** Colum **/}
                    <div
                        className="relative flex flex-col justify-between bg-[#f7eae8]">

                        <div className="lg:px-10 px-5 lg:pt-10 pt-5 lg:pb-0 pb-5">
                            <div
                                className="space-y-8 lg:space-y-10 relative z-20 px-4 pt-6 lg:pt-4 lg:px-7 sm:px-7">
                                <h1 className="hidden">{fsData?.fs_event_name}</h1>
                            </div>

                            <h2 className="mb-2 text-5xl sm:text-6xl uppercase font-bold">{fsData?.fs_description_name}</h2>
                            <h3 className="mb-4 sm:text-xl leading-1 lg:max-w-[550px]">{fsData?.fs_description_slogan}</h3>

                            <div className="flex sm:gap-8 gap-4 mb-4">

                                <div className="sm:mr-5 mr-2 flex flex-wrap items-center mb-0">
                                    <div
                                        className="w-[40px] h-[40px] mr-[15px] rounded-full p-2 flex items-center justify-center">
                                        <IoCalendarOutline className="text-[#8f78be] text-4xl "/>
                                    </div>
                                    <div className="w-[calc(100%-60px)]">{fsData?.fs_date}</div>
                                </div>

                                <div
                                    className="place-info flex flex-wrap items-center max-w-[250px] sm:max-w-[400px] relative">
                                    <div
                                        className="w-[40px] h-[40px] mr-[15px] rounded-full p-2 flex items-center justify-center">
                                        <MdOutlinePlace className="text-[#8f78be] text-4xl rounded-full"/>
                                    </div>
                                    <div className="w-[calc(100%-60px)] leading-tight">Київ</div>
                                    <div
                                        className="absolute opacity-0 place_popover border-1 border-black bg-white w-[250px] p-2 text-[13px]">{fsData?.fs_place}</div>
                                </div>

                            </div>

                        </div>

                        <div className="lg:px-10 px-5 lg:pb-10 pb-5">
                            <div className="w-full lg:max-w-[550px]">
                                {/*<Form/>*/}
                                <p>Івент розпочався!</p>
                            </div>
                        </div>


                    </div>

                    {/** Colum **/}
                    <FirstScreenSpeacers slider_data={fsData?.fs_speacers_slider}/>
                </div>

            </ScrollAnimation>

            <ScrollAnimation
                animatePreScroll="true"
                offset="0"
                animateIn="animate__fadeInUp"
                delay="0"
                className="absolute top-0 left-0 right-0 z-20 h-full m-auto"
                style={{backgroundImage: `url(${Flower})`,backgroundAttachment: "fixed"}} />

            <div className="bg-[#8f78be] absolute right-0 top-0 w-2/3 h-full" id="fs_bg"/>
        </section>
    )
}

export default FirstScreenSlider